var EndlessList = /** @class */ (function () {
    function EndlessList(obj, type) {
        this.type = type;
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = [];
        if (obj && obj.items) {
            for (var i = 0; i < obj.items.length; i++) {
                /* eslint-disable new-cap */
                this.items.push(new this.type(obj.items[i]));
                /* eslint-enable new-cap */
            }
        }
    }
    return EndlessList;
}());
export { EndlessList };
